export default __webpack_public_path__ + "images/0xfea7a6a0b346362bf88a9e4a88416b77a57d6c2a.png";